import { PhoneCall } from "lucide-react";
import { ehColunaCobranca, cobradoHoje, tempoParadoLabel, SLA_COBRANCA_MS } from "../utils/cobrancaCliente";

// MELHORIA 13 — selo no card do kanban pras colunas de cobrança (demandas /
// aguardando cliente). Informativo (todos veem); a ação fica no lembrete/drawer.
// Amarelo = a cobrar; vermelho = passou de 48h; verde = já cobrado hoje.
export function SeloCobrancaCard({ status, statusDesde, ultimaCobrancaEm }: {
  status?: string | null;
  statusDesde?: string | null;
  ultimaCobrancaEm?: string | null;
}) {
  if (!ehColunaCobranca(status)) return null;
  const desde = statusDesde ? new Date(statusDesde).getTime() : Date.now();
  const paradoMs = Math.max(0, Date.now() - desde);
  const estourado = paradoMs > SLA_COBRANCA_MS;
  const feito = cobradoHoje(ultimaCobrancaEm);

  const cls = estourado
    ? "bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800"
    : feito
    ? "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800"
    : "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800";
  const txt = estourado
    ? `Parado há ${tempoParadoLabel(paradoMs)} · +48h!`
    : feito
    ? `Cliente cobrado hoje · há ${tempoParadoLabel(paradoMs)}`
    : `Cobrar cliente · há ${tempoParadoLabel(paradoMs)}`;

  return (
    <div
      className={`mt-2 flex items-center gap-1 text-[10px] font-medium px-1.5 py-1 rounded border ${cls}`}
      title="Card depende do cliente — o atendimento precisa cobrar diariamente (meta: máx 48h parado)"
    >
      <PhoneCall size={11} className="shrink-0" />
      <span className="truncate">{txt}</span>
    </div>
  );
}
